export const TOOL_EXECUTOR_NODE_NAME = 'PartialExecutionToolExecutor';
